import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, UntypedFormArray } from '@angular/forms';

@Component({
    selector: 'app-frt-shipment-seal-purchase',
    templateUrl: './frt-shipment-seal-purchase.component.html',
    styleUrls: ['./frt-shipment-seal-purchase.component.css'],
    standalone: false
})
export class FrtShipmentSealPurchaseComponent implements OnInit {

  frtSealOrPurchaseOrderForm: UntypedFormGroup;
  @Input()
  public inputData: any[];
  @Input()
  public title: string;
  @Input()
  public isCarrierView: boolean;
  @Input()
  public name: string;

textFieldsGroup: any;
  @Output() action = new EventEmitter();
  constructor(private bsModalRef: BsModalRef, private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    const numbers = Array(10).fill(null);
    if (this.inputData != null && this.inputData != undefined) {
      for (let i = 0; i < this.inputData.length; i++) {
        numbers[i] = this.inputData[i];
      }
    }
    console.log(JSON.stringify(this.inputData));
    if(this.name === 'seal') {
    this.textFieldsGroup = new UntypedFormArray(numbers.map(item => new UntypedFormGroup({
      id: new UntypedFormControl(item? item.frtShipmentSealNosId:null),
      text: new UntypedFormControl(item? item.sealNumber:null)
    })));
  } else {
    this.textFieldsGroup = new UntypedFormArray(numbers.map(item => new UntypedFormGroup({
      id: new UntypedFormControl(item? item.frtShipmentPurchaseOrderId:null),
      text: new UntypedFormControl(item? item.purchaseOrderNumber:null)
    })));
  }
    this.frtSealOrPurchaseOrderForm = this.formBuilder.group({
      sealOrPurchaseNumbers: this.textFieldsGroup
    });
  }

  updateSealOrPurchaseNumbers() {
    this.action.emit(this.frtSealOrPurchaseOrderForm.get('sealOrPurchaseNumbers').value);
    this.bsModalRef.hide();
  }

  cancel() {
    this.bsModalRef.hide();
  }
}
